import { render, staticRenderFns } from "./OpportunitiesFilter.vue?vue&type=template&id=3a5ded1b&"
import script from "./OpportunitiesFilter.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports